/** Heading for a group of entry values by page (history / entry cards). */
export function formatEntryValuesPageHeading(
    pageLabel: string | null | undefined,
    pageIndex: number | null | undefined
): string {
    const trimmed = pageLabel?.trim();
    if (trimmed) return trimmed;
    if (pageIndex != null) return `Page ${pageIndex}`;
    return "Calculated Scores";
}
